import { gql } from "@apollo/client";

export const GET_CITIES = gql`
  query GetCity {
    getCity {
      count
      currentPage
      message
      nextPage
      prevPage
      success
      totalPages
      result {
        provinceId
        cityId
        cityName
        createdBy
        createdDate
        isActive
        modifiedBy
        modifiedDate
        include
      }
    }
  }
`;
